import { render, staticRenderFns } from "./theDataCard.vue?vue&type=template&id=bd897516&scoped=true"
import script from "./theDataCard.vue?vue&type=script&lang=js"
export * from "./theDataCard.vue?vue&type=script&lang=js"
import style0 from "./theDataCard.vue?vue&type=style&index=0&id=bd897516&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd897516",
  null
  
)

export default component.exports